module.exports = __webpack_public_path__ + "img/unselected-sector.c7b1bbab.svg";